import { render, staticRenderFns } from "./DescritoresForm.vue?vue&type=template&id=5fad0754"
import script from "./DescritoresForm.vue?vue&type=script&lang=js"
export * from "./DescritoresForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports